import { render, staticRenderFns } from "./LaftItem.vue?vue&type=template&id=9cc58482&scoped=true&"
import script from "./LaftItem.vue?vue&type=script&lang=js&"
export * from "./LaftItem.vue?vue&type=script&lang=js&"
import style0 from "./LaftItem.vue?vue&type=style&index=0&id=9cc58482&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cc58482",
  null
  
)

export default component.exports